import { render } from "./MultiSelectV2.vue?vue&type=template&id=2f57725d"
import script from "./MultiSelectV2.vue?vue&type=script&lang=js"
export * from "./MultiSelectV2.vue?vue&type=script&lang=js"

import "./MultiSelectV2.vue?vue&type=style&index=0&id=2f57725d&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__